import React from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { getBackendDataCollectionsExtensionsDir } from '@wix/cli-astro-definitions';
import { useWixCliAstroBi } from '../../../bi/index.js';
import { useProjectModel } from '../../../model.js';
import { useDataCollectionNameValidation } from '../../../dev-center/components/validations/index.js';
import { useWizardStep } from '../Wizard.js';

export const ChooseCollectionStep: FC<{
  collectionName?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, collectionName }) => {
  const { model } = useProjectModel();
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();
  const collectionsDir = getBackendDataCollectionsExtensionsDir(
    model.projectFolder
  );
  const validateCollectionName =
    useDataCollectionNameValidation(collectionsDir);

  return (
    <TextInput
      isActive={isActive}
      label={'Enter the new collection name:'}
      placeholder={collectionName ?? 'Items'}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Enter the new collection name:',
          questionKey:
            'generate_command.data_collection.choose_collection_name',
          answer: value,
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateCollectionName}
    />
  );
};
